export default __webpack_public_path__ + "assets/AccuTilt-main.51820870.png";